<template>
  <div class="footer">
    <div class="m">
      <div class="footer_bottom">
<!--        <dl>-->
<!--          <dt>-->
<!--            <a>友情链接：</a>-->
<!--          </dt>-->
<!--          <dd>-->
<!--            <a href="http://gdstc.gd.gov.cn/" target="_blank">广东省科学技术厅</a>-->
<!--          </dd>-->
<!--          <dd>-->
<!--            <a href="http://www.gdppnet.com/" target="_blank">广东省生产力促进中心</a>-->
<!--          </dd>-->
<!--          <dd>-->
<!--            <a href="http://kjj.gz.gov.cn/" target="_blank">广州市科学技术局</a>-->
<!--          </dd>-->
<!--          <dd>-->
<!--            <a href="http://stic.sz.gov.cn/" target="_blank">深圳市科技创新委员会</a>-->
<!--          </dd>-->
<!--          <dd>-->
<!--            <a href="http://www.gzns.gov.cn/" target="_blank">广州市南沙区人民政府</a>-->
<!--          </dd>-->
<!--          <dd>-->
<!--            <a href="https://www.sctcc.cn/#/" target="_blank">华转网</a>-->
<!--          </dd>-->
<!--          &lt;!&ndash; <dd>-->
<!--            <a href="http://gnii.com.cn/" target="_blank">南沙产投</a>-->
<!--          </dd>-->
<!--          <dd>-->
<!--            <a href="http://www.gzpc.org.cn/" target="_blank">广州生产力</a>-->
<!--          </dd>-->
<!--          <dd>-->
<!--            <a href="https://inno.emsd.gov.hk" target="_blank">香港创新科技协作平台</a>-->
<!--          </dd>-->
<!--          <dd>-->
<!--            <a href="https://www.fdct.gov.mo/zh_tw/introduction.html" target="_blank">澳门科技发展基金</a>-->
<!--          </dd>-->
<!--          <dd>-->
<!--            <a href="https://www.sctcc.cn/#/ns" target="_blank">知产mall</a>-->
<!--          </dd> &ndash;&gt;-->
<!--        </dl>-->
        <div class="footer_bottom_banquan">
          版权所有：广东省华南技术转移中心有限公司&nbsp;&nbsp;&nbsp;&nbsp;
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
          >粤ICP备18077262号</a>
<!--          <div style="padding: 0 10px">-->
<!--            <a-->
<!--              target="_blank"-->
<!--              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011502001117"-->
<!--              style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"-->
<!--            >-->
<!--              <img :src="imgUrl.anbei" style="float:left;width: 20px;height: 20px;" />-->
<!--              <p-->
<!--                style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#fff;"-->
<!--              >粤公网安备 44011502001117号</p>-->
<!--            </a>-->
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import official from "@/assets/img/erweima/official.jpg";
import customer_service from "@/assets/img/erweima/customer_service.png";
import anbei from "@/assets/img/icon/anbei.png";
export default {
  components: {
  },
  data() {
    return {
      imgUrl: {
        official,
        customer_service,
        anbei: anbei
      },
      show_index: -1
    };
  },
  methods: {}
};
</script>

<style lang="scss">
.footer {
  .bdbtm {
    border-bottom: 1px solid #45494b;
  }
  background: #384662;
  .footer_main {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 18px 0 10px;
  }
  .footer_main_l {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
  }
  .footer_nav {
    margin-right: 96px;
    dt {
      height: 34px;
      line-height: 34px;
      a {
        font-size: 14px;
        color: #e4edee;
      }
      margin-bottom: 25px;
      text-align: left;
    }
    dd {
      height: 30px;
      line-height: 30px;
      text-align: left;
      a {
        font-size: 14px;
        color: #80858c;
      }
    }
  }
  .footer_main_r {
    display: flex;
    // width: 300px;
    div {
      margin-left: -35px;
      text-align: center;
      cursor: pointer;
      width: 96px;
      img {
        width: 30px;
        height: 30px;
      }
      .er_code {
        margin: 0;
        position: relative;
        margin-top: 15px;
        z-index: 1;
        img {
          width: 96px;
          height: 96px;
          display: block;
          margin: 0 auto;
        }
      }
      .er_code::before {
        content: "";
        display: block;
        width: 30px;
        height: 30px;
        background: #fff;
        position: absolute;
        top: -1px;
        left: 50%;
        transform: translate3d(-50%, 0, 0) rotateZ(45deg);
        z-index: -100;
      }
      p {
        height: 34px;
        line-height: 34px;
        font-size: 14px;
        color: #e4edee;
        text-align: center;
      }
    }
  }
  .footer_bottom {
    font-size: 14px;
    padding: 24px 0 28px;

    dl {
      display: flex;
      justify-content: center;
      a {
        color: #fff;
      }
    }
    dd {
      padding: 0 10px;
      border-right: 1px solid #45494b;
    }
    dd.last {
      border: 0;
    }
    .footer_bottom_banquan {
      margin-top: 26px;
      display: flex;
      align-items: center;
      /*text-align: center;*/
      justify-content: center;
      color: #fff;
      a {
        color: #fff;
      }
    }
  }
}
</style>
